import { render, staticRenderFns } from "./area-modal.vue?vue&type=template&id=3baeaa5c&"
import script from "./area-modal.vue?vue&type=script&lang=js&"
export * from "./area-modal.vue?vue&type=script&lang=js&"
import style0 from "./area-modal.vue?vue&type=style&index=0&id=3baeaa5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports